import { makeRequest } from '../../../../lib/api';
import {
  CreatePartnerInsuranceBindingRequest,
  UpdatePartnerInsuranceBindingRequest,
  PartnerInsuranceByOfficeAndServiceRequest,
} from './partnerInsurancesApi';

const PARTNER_INSURANCES_PATH = '/v1/partner_insurance_binding';
const PARTNER_INSURANCE = '/v1/partner_insurance';

export const partnerInsurancesController = {
  createPartnerInsuranceBinding: (data: CreatePartnerInsuranceBindingRequest): Promise<any> => {
    return makeRequest('post', PARTNER_INSURANCES_PATH, data);
  },
  updatePartnerInsuranceBinding: (id: string, data: UpdatePartnerInsuranceBindingRequest): Promise<any> => {
    return makeRequest('put', `${ PARTNER_INSURANCES_PATH }/${ id }`, data);
  },
  getPartnerInsuranceBindingsByPartnerId: (partnerId: string): Promise<any> => {
    return makeRequest('get', `${ PARTNER_INSURANCES_PATH }/partner/${ partnerId }`);
  },

  deletePartnerInsuranceBinding: (id: string): Promise<any> => {
    return makeRequest('delete', `${ PARTNER_INSURANCES_PATH }/${ id }`);
  },

  getPartnerInsuranceByOfficeAndService: (request: PartnerInsuranceByOfficeAndServiceRequest): Promise<any> => {
    const param:string = `serviceId=${ request.serviceId }&officeId=${ request.officeId }`;
    return makeRequest('get', `${ PARTNER_INSURANCE }?${ param }`);
  },

};
